export const ORDER_CONFIRMATION_SUBMIT_ORDER = 'ORDER_CONFIRMATION_SUBMIT_ORDER'
export const ORDER_CONFIRMATION_INITIATE_SAMPLES_FAILURE =
  'ORDER_CONFIRMATION_INITIATE_SAMPLES_FAILURE'
export const ORDER_CONFIRMATION_INITIATE_SAMPLES_PENDING =
  'ORDER_CONFIRMATION_INITIATE_SAMPLES_PENDING'
export const ORDER_CONFIRMATION_INITIATE_SAMPLES_SUCCESS =
  'ORDER_CONFIRMATION_INITIATE_SAMPLES_SUCCESS'
export const RESET_ORDER_CONFIRMATION_STATE = 'RESET_ORDER_CONFIRMATION_STATE'
